import { useSyncExternalStore } from 'react';
import { getSiteLang, LANG_KEY } from '../utils/siteLang.js';

function subscribe(onStoreChange) {
  const onStorage = (e) => {
    if (!e.key || e.key === LANG_KEY) onStoreChange();
  };
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}

function getSnapshot() {
  return getSiteLang();
}

/** Current site language (en | fr | ar) — updates after language switch reload. */
export function useSiteLang() {
  return useSyncExternalStore(subscribe, getSnapshot, () => 'en');
}
